import React, { useEffect } from "react";

const CountdownTimer = () => {
  useEffect(() => {
    const script = document.createElement("script");
    script.src = "https://cdn.logwork.com/widget/countdown.js";
    script.async = true;
    document.body.appendChild(script);
  }, []);

  return (
    <div className="mt-4 text-start">
      {/* Custom label with control over style */}
      <h4 style={{ fontSize: '16px', fontWeight: 'bold', color: '#fff' }} className="merriweather-sans">
        ICO Will Start Soon..
      </h4>

      {/* Countdown widget (non-clickable) */}
      <a
        href="https://logwork.com/countdown-timer"
        onClick={(e) => e.preventDefault()}
        className="countdown-timer"
        data-timezone="Asia/Kolkata"
        data-textcolor="#ffffff"
        data-date="2025-06-02 12:00"
        data-background="#353636"
        data-digitscolor="#24ccff"
        data-unitscolor="#ffffff"
        style={{
          pointerEvents: "none",
          textDecoration: "none",
          display: "inline-block",
          
        }}
      >   Hurry Up </a>
    </div>
  );
};

export default CountdownTimer;
